import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    config: {},
    welcomeBanner: "",
    iconConfig: {},
    recommendations: [],
    openConfetti: false,
    promotionConfig: [],
    openFreeItemByValueModal: false,
    firstTimeOpenFreeItemByValueModal: false,
    storeClosed: false,
    serviceChargeList: [],
  },
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    setWelcomeBanner: (state, action) => {
      state.welcomeBanner = action.payload;
    },
    setIconConfig: (state, action) => {
      state.iconConfig = action.payload;
    },
    setRecommendations: (state, action) => {
      state.recommendations = action.payload;
    },
    setOpenConfetti: (state, action) => {
      state.openConfetti = action.payload;
    },
    setPromotionConfig: (state, action) => {
      state.promotionConfig = action.payload;
    },
    setOpenFreeItemByValueModal: (state, action) => {
      state.openFreeItemByValueModal = action.payload;
    },
    setFirstTimeOpenFreeItemByValueModal: (state, action) => {
      state.firstTimeOpenFreeItemByValueModal = action.payload;
    },
    setStoreClosed: (state, action) => {
      state.storeClosed = action.payload;
    },
    setServiceChargeList: (state, action) => {
      state.serviceChargeList = action.payload || [];
    },
  },
});

export const appReducer = appSlice.reducer;
export const {
  setConfig,
  setWelcomeBanner,
  setIconConfig,
  setRecommendations,
  setOpenConfetti,
  setPromotionConfig,
  setOpenFreeItemByValueModal,
  setFirstTimeOpenFreeItemByValueModal,
  setStoreClosed,
  setServiceChargeList,
} = appSlice.actions;
